import { Box, BoxProps } from "@mui/material";
import LogoColorSmall from "./logo-color-small.svg?react";
import LogoMonoSmall from "./logo-mono-small.svg?react";

export function LogoEye({ dark, ...props }: Omit<BoxProps, "children"> & { dark?: boolean }) {
  return (
    <Box overflow="hidden" {...props}>
      {dark ? (
        <LogoMonoSmall width="100%" height="100%" />
      ) : (
        <LogoColorSmall width="100%" height="100%" />
      )}
    </Box>
  );
}
